export const CONSTVersion = {
    version: '2026.0.22.0',
};
